import { useQuery } from '@tanstack/react-query'

import { marketShopAPI } from '@/api/new-api'
import { ResidentModel } from '@/models'

export const getClientQueryKey = () => ['useGetClient']

export const getClient = async () => {
  const response = await marketShopAPI.get<ResidentModel>('/client')
  return response.data
}

export interface UseGetClientProps {
  enabled?: boolean
}

export const useGetClient = ({ enabled }: UseGetClientProps = {}) => {
  return useQuery({
    enabled,
    queryFn: () => getClient(),
    queryKey: getClientQueryKey(),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retryOnMount: false,
  })
}
